<template>
  <div
    ref="chat"
    :class="{position: chatDialog}"
    class="chat_page_root flex"
  >
    <img
      v-if="chatDialog"
      src="http://img.yimutian.com/misc/5d199edc885b9303cb1b94a0f74304bf.png"
      class="close"
      @click="close"
    >
    <contactsList />
    <chatList :is-douniu="isDouniu" />
    <orderList v-show="peer_uid" />
  </div>
</template>
<script>
import contactsList from '@/components/chat/contactsList'
import chatList from '@/components/chat/chatList'
import orderList from '@/components/chat/orderList'
import { mapState } from 'vuex'
import { chat, publish } from '@/api'
export default {
  name: 'Chat',
  components: {
    contactsList,
    chatList,
    orderList
  },
  data() {
    return {
      isDouniu: true,
    }
  },
  computed: {
    ...mapState({
      peer_uid: state => state.chat.peer_uid,
      winHeight: state => (state.winHeight - 130) + 'px',
      chatDialog: state => state.chatDialog
    })
  },
  created() {
    this.checkIfDonNiu() // 校验是否豆牛角色 ,可以进行买家ID搜索
  },
  methods: {
    checkIfDonNiu() {
      publish.checkPrevillige({resId: 1246}).then(({data: res}) => {
        this.isDouniu = res.data
      })
    },
    close() {
      this.$store.commit('setchatDialog', false)
    }
  }
}
</script>

<style lang="less" scoped>
.chat_page_root {
  background-color: #FFFFFF;
  font-family: HelveticaNeue;
  color:#333333;
  height: 100%;
  // overflow: hidden;
}
.position{
    position: absolute;
    top: 10%;
    left: 10%;
    background: #ffffff;
    z-index: 100;
    height: 80%;
    width: 80%;
}
.chat_container {
  display: flex;
  height: 100%;
  min-height: 6rem;
  overflow: auto;
  overflow-y: auto;
}
.close{
  position: absolute;
  top: -24px;
  right: -24px;
  z-index: 102;
  width: 24px;
  height: 24px;
}
</style>
